import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'

const requestUtil = axios.create({
  // baseURL: "https://app.pro.anxiaostore.com/axd",
  // baseURL: 'https://api.test.anxiaostore.com/axd',
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://172.16.0.106:9019/axd',
  timeout: 30000
})

// 请求拦截器
requestUtil.interceptors.request.use(
  (config) => {
    // console.log(store.state.user.token, "111111");
    if (config.method === 'post' && config.url === '/file/upload') {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else if (config.method === 'post' && config.url === '/app/sendCode') {
      config.headers['Content-Type'] = 'application/json'
      config.headers['User-tag'] = store.state.user.userTag
    } else {
      config.headers['Content-Type'] = 'application/json'
    }
    config.headers.Authorization = encodeURIComponent(store.state.user.token)
    // config.headers.Authorization = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6Ijg5ZThmMjk2LWYyM2UtNDM0Yy1iOGFlLWFhYTgzOGMwMGY4MiJ9.zqJXZ3QGLPri1Ved8A_uL8s1GUCSTDg76haHZJPHPFduPEiIEGxXGdZFJGkC3nFxbQxOL1KgVBDquWPXib9vOA'
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
requestUtil.interceptors.response.use(
  (response) => {
    // 返回数据为0/200时才处理，其他状态直接抛出错误提示
    if (response.data.code === 0 || response.data.code === 200) {
      return response.data
    } else {
      // 401 token失效
      if (response.data.code === 401) {
        // location.replace(`/pos?sn=${store.state.user.SN}`);
        console.log('token过期')
      }
      console.log(response, '响应结果')
      Message.error(response.data.msg)
      return Promise.reject(response.data.msg)
    }
  },
  (error) => {
    let { message } = error
    // if (message != 'Network Error') {
      Message.error(message)
    // }
    return Promise.reject(error)
  }
)

export default requestUtil
